import { render, staticRenderFns } from "./TableMatchContracts.vue?vue&type=template&id=19310e3c&"
import script from "./TableMatchContracts.vue?vue&type=script&lang=js&"
export * from "./TableMatchContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports